import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'app',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (
      window.confirm(
        `Are you sure you want to uninstall the app? It will delete all of its records from this tenant.`
      )
    ) {
      submit({ type: 'uninstall' })
    }
  }
}
